import { render, staticRenderFns } from "./AddSubscription.vue?vue&type=template&id=1dc85baa&"
import script from "./AddSubscription.vue?vue&type=script&lang=js&"
export * from "./AddSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports